import React from 'react';
import TariffType from './tariffTypeMain';
import TranslationService from "../../service/TranslationService";
import {BACK, CHOOSE, CHOOSE_CITY, CHOOSE_MUNICIPALITY, TARIFF_MODEL, TARIFF_TYPE} from "../../language-content/keys";
import Autocomplete from "react-autocomplete";

export const tariffTypesMain = (props) => {
    return (
        <section className="small-hero-channels">
            <div className="container h-100">
                <div className="row h-100">
                    <div
                        className="col-12 h-100 position-relative align-items-center d-flex justify-content-center flex-column flex-md-row">
                        {showCitiesAndMunicipalities()}
                        <div className="tariff_models bottom">
                            {displayTariffTypes()}
                            {displayTariffTypesMobile()}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

    function displayTariffTypes() {
        return (
            <div
                className="row d-none d-md-flex align-items-center justify-content-center h-100 sans-regular text-center">

                {props.tariffTypes.map(tt => {
                    return (
                        <TariffType tt={tt}
                                    tariffModelShortNames={props.tariffModelShortNames}
                                    toggleTariffChangeModal={(url) => props.toggleTariffChangeModal(url)}
                                    selectedTariffModel={props.selectedTariffModel}
                                    history={props.history}/>
                    )
                })}

            </div>
        )
    }

    function displayTariffTypesMobile() {
        const tariffType = props.tariffTypes && props.tariffTypes.length > 0 && props.tariffTypes.find(tt => tt.tariffType.id == props.selectedTariffType);
        const tariffModels = tariffType ? tariffType.tariffModels : [];

        return (
            <div className="d-block d-md-none">
                <h5 className="serif-bold"> {TranslationService.translate(TARIFF_TYPE, props.lang)}</h5>
                <select className="form-control rounded-0 mb-3" value={props.selectedTariffType}
                        disabled={!props.selectedCity || !props.selectedMunicipality}
                        onChange={(e) => props.history.push(`/tv-channels?tariffType=${e.target.value}`, e)}>
                    <option selected disabled> {TranslationService.translate(CHOOSE, props.lang)}</option>
                    {props.selectedCity && props.selectedMunicipality && props.tariffTypes.map(tt => {
                        return (
                            <option id={`tt-mobile-${tt.tariffType.id}`} key={`tt-mobile-${tt.tariffType.id}`}
                                    value={tt.tariffType.id}>
                                {tt.tariffType.name}
                            </option>
                        )
                    })}
                </select>

                <h5 className="serif-bold"> {TranslationService.translate(TARIFF_MODEL, props.lang)}</h5>

                <select className="form-control rounded-0 mb-3" disabled={!props.selectedTariffType || !props.selectedCity || !props.selectedMunicipality}
                        value={props.selectedTariffModel}
                        onChange={(e) => props.history.push(`/tv-channels?tariffType=${props.selectedTariffType}&tariffModel=${e.target.value}`, e)}>
                    <option selected disabled> {TranslationService.translate(CHOOSE, props.lang)}</option>
                    {props.selectedCity && props.selectedMunicipality && tariffModels.map(tm => {
                        return (
                            <option id={`tm-mobile-${tm.id}`} key={`tm-mobile-${tm.id}`} value={tm.id}>
                                {props.tariffModelShortNames && props.tariffModelShortNames[tm.id] ? props.tariffModelShortNames[tm.id] : tm.name}
                            </option>
                        )
                    })}
                </select>

            </div>
        )
    }

    function showCitiesAndMunicipalities() {
        var opts = {};
        if (props.showChangeCityBtn) {
            opts['disabled'] = 'disabled';
        }
        return (
            <div className="row position-relative w-100 cities-and-municipalities">
                <div className={tariffTypeClassName()}><h5
                    className="text-white serif-bold lead-text"> {TranslationService.translate(CHOOSE_CITY, props.lang)} </h5>
                    <Autocomplete
                        value={props.selectedCityName}
                        onChange={(e) => props.setSelectedCityName(e.target.value)}
                        onSelect={(value, item) => {
                            props.selectCity(item.id)


                        }}
                        getItemValue={(item) => item.label}
                        items={props.autocompleteCities.map(c => {
                            return {id: c.id, label: translateName(c)}
                        })}
                        renderItem={(item, isHighlighted) =>
                            <div className="p-1" key={'city' + item.id}
                                 style={{background: isHighlighted ? 'lightgray' : 'white'}}>
                                <span style={{paddingLeft: "8px"}}> {item.label} </span>
                            </div>
                        }
                        renderInput={(inputProps) => (
                            <div className={"col-12"}>
                                <input
                                    type="text" {...opts}
                                    className={`form-control rounded-0 serif-bold autoselect-input ${props.showChangeCityBtn ? 'disabled' : ''}`}
                                    {...inputProps}
                                />
                            </div>
                        )}
                        renderMenu={(items, value, style) =>
                            <div className={"col-12"} style={{
                                marginTop: "0px",
                                left: '0px',
                                right: '0',
                                position: 'absolute',
                                width: "auto",
                                zIndex: 100
                            }}>
                                <div style={{overflowY: 'auto', height: '140px'}} children={items}/>
                            </div>
                        }
                        wrapperProps={{className: "row autoselect-wrapper d-block position-relative"}}
                    />
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xl-3 px-0 pl-md-2"><h5
                    className="text-white serif-bold lead-text mt-4 mt-md-0"> {TranslationService.translate(CHOOSE_MUNICIPALITY, props.lang)} </h5>
                    <Autocomplete
                        ref={props.municipalityInputRef}
                        value={props.selectedMunicipalityName}
                        onChange={(e) => props.setSelectedMunicipalityName(e.target.value)}
                        onSelect={(value, item) => {
                            props.selectMunicipality(item.id)
                        }}
                        getItemValue={(item) => item.label}
                        items={props.autocompleteMunicipalities.map(m => {
                            return {id: m.id, label: translateName(m)}
                        })}
                        renderItem={(item, isHighlighted) =>
                            <div className="p-1" key={'mun' + item.id}
                                 style={{background: isHighlighted ? 'lightgray' : 'white'}}>
                                <span style={{paddingLeft: "8px"}}> {item.label} </span>
                            </div>
                        }
                        renderInput={(inputProps) => (
                            <div className={"col-12"}>
                                <input
                                    type="text" {...opts}
                                    className={`form-control rounded-0 mb-3 serif-bold autoselect-input ${props.showChangeCityBtn ? 'disabled' : ''}`}
                                    {...inputProps}
                                />
                            </div>
                        )}
                        renderMenu={(items, value, style) =>
                            <div className={"col-12"} style={{
                                marginTop: "-16px",
                                left: '0px',
                                right: '0',
                                position: 'absolute',
                                width: "auto",
                                zIndex: 100
                            }}>
                                <div style={{overflowY: 'auto', height: '140px'}} children={items}/>
                            </div>

                        }
                        wrapperProps={{className: "row autoselect-wrapper d-block position-relative"}}
                    />
                </div>
                <div className="col-12 col-lg-12 col-xl-3 px-0 px-xl-2">
                    <h5 className="text-white serif-bold lead-text d-none d-xl-block"> &nbsp; </h5>
                    <a type="button"  href={window.location.origin + window.location.pathname}
                            className={`btn btn-sm btn-primary no-icon py-2 btn-block ${props.showChangeCityBtn ? '' : 'd-none'} `}
                            id="btn-change-city">
                        промени град/општина
                    </a>
                </div>
            </div>
        )
    }

    function tariffTypeClassName() {
        if(props.showChangeCityBtn){
            return 'col-12 col-md-6 col-lg-6 col-xl-3 offset-xl-2 px-0 pr-md-2'
        }else{
            return 'col-12 col-md-6 col-lg-6 col-xl-3 offset-xl-3 px-0 pr-md-2'
        }
    }

    function translateName(obj) {
        if (props.lang === 'en_US') {
            return obj.nameEN
        } else if (props.lang === 'sq_AL') {
            return obj.nameAL
        } else return obj.nameMK
    }
};

export default tariffTypesMain;
